import { motion } from 'framer-motion';
import { luxuryEase, viewportOnce } from '../lib/motion';
import { companyInfo } from '../data/siteData';

const values = [
  {
    n: '01',
    title: 'Kalite ve güven',
    text: 'Her katmanda malzeme, işçilik ve denetim. Müşteri memnuniyeti pazarlama cümlesi değil, teslim kriteridir.',
  },
  {
    n: '02',
    title: 'Uzman kadro',
    text: 'Yüksek inşaat mühendisi ve mimar aynı masada. Statik güvenlik ile mekân kalitesi birbirinden kopmaz.',
  },
  {
    n: '03',
    title: 'Zamanında teslim',
    text: 'Bayramoğlu Ada Konutları referansımızdır: sözleşme takvimine bağlı üretim, şeffaf şantiye.',
  },
];

export default function About() {
  return (
    <section id="about" className="py-24 px-4 sm:px-6 lg:px-8 bg-nosta-paper">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 mb-20">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={viewportOnce}
            transition={{ duration: 0.9, ease: luxuryEase }}
            className="lg:col-span-5"
          >
            <p className="eyebrow mb-4">Kurumsal</p>
            <h2 className="font-display text-4xl md:text-6xl leading-tight">
              Mühendislik ile mimari, aynı imza.
            </h2>
          </motion.div>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={viewportOnce}
            transition={{ delay: 0.12, duration: 0.9, ease: luxuryEase }}
            className="lg:col-span-7 text-lg text-nosta-mute leading-relaxed pt-2 lg:pt-12"
          >
            Nosta Yapı; Esenyurt ofisinden Enez sahasına uzanan, aile disipliniyle yönetilen bir yapı firmasıdır.
            Depreme dayanıklılık ve lüks yaşam aynı cümlede durur — çünkü ikisini de aynı ekip tasarlar ve üretir.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-nosta-line border border-nosta-line mb-20">
          {values.map((v, i) => (
            <motion.div
              key={v.n}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={viewportOnce}
              transition={{ delay: 0.1 * i, duration: 0.85, ease: luxuryEase }}
              className="bg-nosta-paper p-8 md:p-10"
            >
              <div className="eyebrow mb-6">{v.n}</div>
              <h3 className="font-display text-2xl md:text-3xl mb-4">{v.title}</h3>
              <p className="text-nosta-mute leading-relaxed">{v.text}</p>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={viewportOnce}
          transition={{ duration: 0.9, ease: luxuryEase }}
        >
          <p className="eyebrow mb-8 text-center">Ekip</p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
            {companyInfo.team.map((member) => (
              <div
                key={member.name}
                className="border border-nosta-line bg-white p-8 flex items-start gap-5"
              >
                <div className="w-16 h-16 shrink-0 bg-nosta-espresso text-nosta-goldSoft flex items-center justify-center font-display text-xl">
                  {member.name
                    .split(' ')
                    .map((w) => w[0])
                    .join('')}
                </div>
                <div>
                  <div className="eyebrow mb-1">{member.role}</div>
                  <h4 className="font-display text-2xl">{member.name}</h4>
                  <p className="text-nosta-mute mt-1">{member.title}</p>
                  <a
                    href={`tel:${member.phone.replace(/\s/g, '')}`}
                    className="inline-block mt-3 text-sm text-nosta-gold hover:underline"
                  >
                    {member.phone}
                  </a>
                </div>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
